const $ = jQuery.noConflict();
import datepicker from 'js-datepicker';


'use strict';
const datePicker = {

	$datePickerBtn: $('.js-date-picker'),

	init: function() {
		this.togglePickr();
	},

	togglePickr: function() {
		const selector = document.querySelectorAll('.js-date-picker');
		const quoteSelector = document.querySelectorAll('.js-quote-date-picker');

		//Looping through the elements and rendering the date picker
		selector.forEach((item) => {
			// eslint-disable-next-line no-unused-vars
			const pickercf7 = datepicker(item, {
				// minDate: new Date(),
				maxDate: new Date(),

				formatter: (input, date) => {
					const value = date.toLocaleDateString();
					input.value = value; // => '1/1/2099'
				},
				onShow: () => {
					setTimeout(() => {
						datePicker.$datePickerBtn.addClass('active');
					}, 100);
				},
				onHide: () => {
					datePicker.$datePickerBtn.removeClass('active');
				},
			});
		});

		quoteSelector.forEach((item) => {
			// eslint-disable-next-line no-unused-vars
			const quoteDate = datepicker(item, {
				minDate: new Date(),
				formatter: (input, date) => {
					const value = date.toLocaleDateString();
					input.value = value; // => '1/1/2099'
				},
				onShow: () => {
					const siblingArrow = item.nextElementSibling;
					setTimeout(() => {
						item.classList.add('active');
					}, 100);
					setTimeout(() => {
						siblingArrow.classList.add('active');
					}, 50);
				},
				onHide: () => {
					item.classList.remove('active');
				},
				// onSelect: (instance, date) => {
				// 	const toolTip = item.nextElementSibling.nextElementSibling;

				// 	toolTip.classList.add('hidden-title');
				// },
			});
		});
	},

};

export default datePicker;
